import React, {useContext} from "react";
import "../css/sign.css"
import AuthContext from "../context/AuthContext";

const LoginForm = () => {
  let {loginUser} = useContext(AuthContext)
  const FormButton = (props) => (
    <div id="button" className="rows">
      <button type="submit">{props.title}</button>
    </div>
  );

  const FormInput = (props) => (
    <div className="rows">
      <label>{props.description}</label>
      <input type={props.type} name={props.name} placeholder={props.placeholder} />
    </div>
  );

  return (
    <div>
      <form onSubmit={loginUser}>
      <FormInput
        description="Username"
        placeholder="Enter your username"
        type="text"
        name="username"
      />
      <FormInput
        description="Password"
        placeholder="Enter your password"
        type="password"
        name="password"
      />
      <FormButton title="Log in" />
      </form>
      
    </div>
  );
};

export default LoginForm;
